export const config = {
  placeholder: new Map<string, string>([['[.]', '\xa0']]),
}
